import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EmailButtonMenuComponent } from './email-button-menu.component';


@NgModule({
  declarations: [
    EmailButtonMenuComponent
  ],
  imports: [
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    EmailButtonMenuComponent
  ]
})
export class EmailButtonMenuModule { }
